import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { useAppSelector } from '../../store'
import { TPermissionTypes } from '../constants/menu'

export const useCheckPermission = ({ page }: { page: TPermissionTypes }) => {
  const { user } = useAppSelector((s) => s.app)
  const { festivalName } = useParams()

  const hasEditPermission = useMemo(() => {
    const festival = user?.festivalsPermissions.find(
      (o) => o.festivalName === festivalName,
    )

    if (user?.superAdmin) {
      return true
    }

    if (!festival) {
      return false
    }

    if (festival.permissions.find((o) => o.type === page)?.edit) {
      return true
    }

    return false
  }, [user?.festivalsPermissions, festivalName])

  return { hasEditPermission }
}
